import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="/images/logo-Innexia-blanco.png"
                alt="Innexia Logo"
                className="footer-logo-img"
              />
            </div>
            <p className="footer-description">
              Transformación digital con Inteligencia Artificial, Analítica y Desarrollo de Software
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Servicios</h4>
            <ul className="footer-links">
              <li><a href="#servicios">Inteligencia Artificial</a></li>
              <li><a href="#servicios">Analítica de Datos</a></li>
              <li><a href="#servicios">Desarrollo de Software</a></li>
              <li><a href="#servicios">Transformación Digital</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Productos</h4>
            <ul className="footer-links">
              <li><a href="#productos">Para Emprendedores</a></li>
              <li><a href="#productos">Para PYMES</a></li>
              <li><a href="#productos">Plataforma de Aprendizaje</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contacto</h4>
            <ul className="footer-links">
              <li><a href="#contacto">Formulario de Contacto</a></li>
              <li><a href="tel:+50762892432">+507 6289-2432</a></li>
              <li><a href="mailto:info@innexia.ai">info@innexia.ai</a></li>
              <li className="footer-address">
                PH Fuentes de Mallorca Park I<br />
                Av. Transístmica, Ofic. 18C
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Innexia. Todos los derechos reservados.
          </p>
          <button className="scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
            ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

